import {UIEvents, useInjection, visibilityEffect} from "@dp-instant/ui";
import {IEventEmitter, TypesCore} from "@dp-instant/interfaces";
import {Localize} from "@dp-instant/i18n";
import {UIConstants} from "@game/ui/constants";
import {apiClient} from "@game/api/ApiClient";
import {playUIClickSound} from "@game/helpers";
import {Images} from "@game/ui/images";
import cn from "classnames";
import {useState} from "preact/hooks";
import "./NoAdsPurchasePopup.less";

type NoAdsPurchasePopupProps = {
    onConfirm: (confirmed?: boolean) => void;
};

export const NoAdsPurchasePopup = ({onConfirm}: NoAdsPurchasePopupProps) => {
    const [invisible] = visibilityEffect(UIConstants.popup.startDelay);
    const [busy, setBusy] = useState(false);
    const dispatcher = useInjection<IEventEmitter>(TypesCore.dispatcher);

    const closePopup = () => {
        dispatcher.emit(UIEvents.POPUP, {id: null});
    };

    const handlePurchase = async (slug: string) => {
        if (busy) return;
        playUIClickSound();
        setBusy(true);
        try {
            const {paid} = await apiClient.purchaseFlow(slug);
            if (paid) {
                closePopup();
                onConfirm(true);
            } else {
                setBusy(false);
            }
        } catch {
            setBusy(false);
            const tg = (window as any).Telegram?.WebApp;
            tg?.showAlert?.("Payment error. Please try again.");
        }
    };

    const handleCancel = () => {
        playUIClickSound();
        closePopup();
        onConfirm(false);
    };

    return (
        <div className="popups">
            <div className={cn("popup-noads", {invisible})}>
                <div className="popup-noads__handle" />
                <div className="popup__title">{Localize.get("ui-noads-title", "NO ADS")}</div>
                <div className="popup-noads__description">
                    {Localize.get("ui-noads-description", "Get all ad bonuses instantly, no more ads!")}
                </div>
                <div className="popup-noads__rating-boost">
                    {Localize.get("ui-noads-rating-boost", "x2 points in daily rating")} {"🔥"}
                </div>
                <div className="popup-noads__body">
                    <div className="popup-noads__cards">
                        <div
                            className="popup-noads__card"
                            onClick={() => handlePurchase("no_ads_month")}
                        >
                            <div className="popup-noads__card-title">
                                {Localize.get("ui-noads-30days", "30 days")}
                            </div>
                            <div className="popup-noads__card-price">
                                99 <Images.Star />
                            </div>
                        </div>
                        <div
                            className={cn("popup-noads__card", "popup-noads__card--best")}
                            onClick={() => handlePurchase("no_ads_forever")}
                        >
                            <div className="popup-noads__badge">
                                {Localize.get("ui-noads-best", "Best value")}
                            </div>
                            <div className="popup-noads__card-title">
                                {Localize.get("ui-noads-forever", "Forever")}
                            </div>
                            <div className="popup-noads__card-price">
                                299 <Images.Star />
                            </div>
                        </div>
                    </div>

                    <button
                        className="popup-noads__cancel"
                        disabled={busy}
                        onClick={handleCancel}
                    >
                        {busy ? "..." : Localize.get("ui-noads-cancel", "CANCEL")}
                    </button>
                </div>
            </div>
        </div>
    );
};
